document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[id^="discovery-set-"]').forEach(initDiscoverySet);

  function initDiscoverySet(container) {
    const limit = parseInt(container.dataset.limit, 10) || 3;
    const elements = {
      addButtons: container.querySelectorAll('.discovery-set__add'),
      list: container.querySelector('.discovery-set__list'),
      counter: container.querySelector('.discovery-set__counter'),
      addToCartBtn: container.querySelector('.discovery-set__add-to-cart'),
      progressBar: container.querySelector('.discovery-set__progress-bar'),
      grid: container.querySelector('.discovery-set__grid'),
      priceDisplay: container.querySelector('.total_card_price')
    };

    let selected = [];

    elements.addButtons.forEach(btn => {
      btn.addEventListener('click', () => handleAddToSet(btn));
    });

    function handleAddToSet(btn) {
      const card = btn.closest('.discovery-set__card');
      const { productId, variantId, title, image, price } = getCardData(card);

      if (selected.find(s => s.variantId === variantId) || selected.length >= limit) {
        return showFeedback(btn, 'Límite alcanzado', 1200);
      }

      btn.classList.add('is-loading');
      btn.textContent = 'Agregando...';

      setTimeout(() => {
        selected.push({ productId, variantId, title, image, price });
        card.classList.add('is-selected');
        btn.classList.add('is-selected', 'is-disabled');
        btn.classList.remove('is-loading');
        btn.textContent = 'Agregado ✓';
        renderSelected();
      }, 300);
    }

    function getCardData(card) {
      return {
        productId: card.dataset.productId,
        variantId: card.dataset.variantId,
        title: card.dataset.title,
        image: card.dataset.image,
        price: parseFloat(card.dataset.price) || 0
      };
    }

    function showFeedback(btn, message, duration) {
      const originalText = btn.textContent;
      btn.classList.add('is-disabled');
      btn.textContent = message;
      setTimeout(() => {
        btn.classList.remove('is-disabled');
        btn.textContent = originalText;
      }, duration);
    }

    function renderSelected() {
      updateList();
      updateProgress();
      updateCardStates();
    }

    function updateList() {
      elements.list.innerHTML = selected.map((item, idx) => `
        <li class="discovery-set__item">
          <img class="discovery-set__item-img" src="${item.image}" alt="" loading="lazy">
          <div class="discovery-set__item-info">
            <div class="discovery-set__item-title">${item.title}</div>
          </div>
          <button class="discovery-set__remove" data-idx="${idx}" type="button" aria-label="Quitar ${item.title}">×</button>
        </li>
      `).join('');

      elements.list.querySelectorAll('.discovery-set__remove').forEach(btn => {
        btn.addEventListener('click', () => removeItem(parseInt(btn.dataset.idx)));
      });
    }

    function updateProgress() {
      const progress = (selected.length / limit) * 100;
      elements.counter.textContent = `${selected.length} / ${limit}`;
      elements.progressBar.style.width = `${progress}%`;

      // Calcular precio total
      const totalPrice = selected.reduce((sum, item) => sum + (item.price || 0), 0);
      const formattedPrice = (totalPrice / 100).toLocaleString('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 2
      });
      elements.priceDisplay.textContent = formattedPrice;

      const isComplete = selected.length >= limit;
      elements.addToCartBtn.disabled = !isComplete;
      elements.grid.classList.toggle('is-complete', isComplete);
    }

    function updateCardStates() {
      elements.addButtons.forEach(btn => {
        const card = btn.closest('.discovery-set__card');
        const isSelected = selected.find(s => s.variantId === card.dataset.variantId);

        card.classList.toggle('is-selected', !!isSelected);
        btn.classList.toggle('is-selected', !!isSelected);

        if (!isSelected) {
          btn.classList.remove('is-disabled');
          btn.textContent = 'Agregar al set';
        }
      });
    }

    function removeItem(idx) {
      const removedItem = selected[idx];
      selected.splice(idx, 1);

      const card = container.querySelector(`[data-variant-id="${removedItem.variantId}"]`);
      if (card) {
        const addBtn = card.querySelector('.discovery-set__add');
        card.classList.remove('is-selected');
        addBtn?.classList.remove('is-selected', 'is-disabled');
        if (addBtn) addBtn.textContent = 'Agregar al set';
      }

      renderSelected();
    }

    elements.addToCartBtn.addEventListener('click', async () => {
      if (selected.length === 0) return;

      const btn = elements.addToCartBtn;
      const originalText = btn.textContent;

      btn.disabled = true;
      btn.classList.add('is-loading');
      btn.textContent = 'Procesando...';

      try {
        for (const item of selected) {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(item.variantId), quantity: 1 })
          }).then(r => {
            if (!r.ok) throw new Error(`Error adding ${item.title}`);
            return r.json();
          });
          await new Promise(resolve => setTimeout(resolve, 100));
        }

        window.location.href = '/checkout';
      } catch (error) {
        console.error('Discovery Set Error:', error);
        btn.disabled = false;
        btn.classList.remove('is-loading');
        btn.textContent = originalText;
        alert('Error al procesar el pedido. Intenta nuevamente.');
      }
    });

  }
});
